import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import {
  CalendarForm,
  type IRange,
  kyrgyzstanSearchStore,
} from 'entities/kyrgyzstan'

import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

const KyrgyzstanCalendarPage = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { setDates, start_date, end_date } = kyrgyzstanSearchStore

  const initialDates: IRange = {
    startDate: start_date,
    endDate: end_date,
  }

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleSubmit = (dates: IRange) => {
    setDates(dates)
    navigate(-1)
  }

  return (
    <div className={clsx('container', s.container)}>
      <HeaderGoBack
        title={t('kyrgyzstan_block.calendar.title')}
        onGoBack={handleGoBack}
        buttonWhite
        variant="grey"
      />

      <CalendarForm
        initialDates={initialDates}
        onSubmit={handleSubmit}
        showSubmitButton
      />
    </div>
  )
})

export default KyrgyzstanCalendarPage
